module.exports = __webpack_public_path__ + "static/hero-913048c7bec87e4e9b55ce067728f206.jpg";